import { useContractReads } from 'wagmi';
import { formatEther } from 'viem';
import { CONTRACT_ADDRESS, CONTRACT_ABI } from '../config/contract';

export function HalvingSchedule() {
  const { data: contractData } = useContractReads({
    contracts: [
      {
        address: CONTRACT_ADDRESS,
        abi: CONTRACT_ABI,
        functionName: 'INITIAL_REWARD',
      },
      {
        address: CONTRACT_ADDRESS,
        abi: CONTRACT_ABI,
        functionName: 'HALVING_INTERVAL',
      },
      {
        address: CONTRACT_ADDRESS,
        abi: CONTRACT_ABI,
        functionName: 'totalMints',
      }
    ],
    watch: true,
  });

  const initialReward = contractData?.[0]?.result ? Number(formatEther(contractData[0].result)) : 50;
  const halvingInterval = contractData?.[1]?.result ? Number(contractData[1].result) : 210000;
  const currentMints = contractData?.[2]?.result ? Number(contractData[2].result) : 0;

  // Calculate max supply (initial supply + all possible mints)
  const maxSupply = 21000000; // Fixed max supply like Bitcoin

  return (
    <div className="card halving-schedule">
      <h2>Halving Schedule</h2>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Phase</th>
              <th>Reward</th>
              <th>Mints</th>
              <th>Target</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 10 }, (_, i) => {
              const reward = initialReward / Math.pow(2, i);
              const targetMints = halvingInterval * (i + 1);
              const isCurrentPhase = currentMints >= i * halvingInterval && 
                                   currentMints < (i + 1) * halvingInterval;
              
              return (
                <tr key={i} className={isCurrentPhase ? 'current-phase' : ''}>
                  <td>{i}</td>
                  <td>{reward.toFixed(2)}</td>
                  <td>{isCurrentPhase ? currentMints.toLocaleString() : '0'}</td>
                  <td>{targetMints.toLocaleString()}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
} 